import { useTranslation } from "react-i18next";

const { CircularProgress } = require("@mui/material");

const Loading = ({ className = "", color = "black" }) => {
  const { t } = useTranslation("uaa");
  return (
    <div className="flex items-center justify-center m-5">
      <CircularProgress className={className} />
      <b className="px-5">{t(`label.loading`)}</b>
    </div>
  );
};

export default Loading;
